import { IndicatorSeparator } from './components/IndicatorSeparator/IndicatorSeparator'
import { DropdownIndicator } from './components/DropdownIndicator/DropdownIndicator'
import { ClearIndicator } from './components/ClearIndicator/ClearIndicator'

export const getCurrentValue = (isMulti, value, options) => {
  if (options.some((el) => 'options' in el)) {
    return options.flatMap((el) =>
      el.options?.filter((item) => value?.includes(item.value))
    )
  } else if (isMulti) {
    return options.filter((item) => value?.includes(item.value))
  }
  return options.find((item) => item.value === value) || null
}

export const getComponents = (
  isMulti,
  customOption,
  customValue,
  customMultiValue
) => {
  const components = {
    ClearIndicator,
    DropdownIndicator,
    IndicatorSeparator
  }

  if (customOption) components['Option'] = customOption
  if (customValue) components['ValueContainer'] = customValue
  if (customMultiValue && isMulti)
    components['MultiValueLabel'] = customMultiValue

  return components
}
